import { Component, Inject, Input, OnInit } from '@angular/core';

import { Formly, QUALIFICATION_FORMLY, QualificationFacade, QualificationService, UntilDestroy, untilDestroyed } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'cng-visio-qualification-workspace',
  templateUrl: './visio-qualification-workspace.component.html',
  styleUrls: ['./visio-qualification-workspace.component.scss'],
  providers: [
    {
      provide: QUALIFICATION_FORMLY,
      useClass: Formly,
    },
  ],
})
export class VisioQualificationWorkspaceComponent implements OnInit {
  @Input() responseId: string;

  canFinishQualification = false;

  constructor(private readonly qualificationFacade: QualificationFacade, @Inject(QUALIFICATION_FORMLY) private readonly formly: Formly) {
    this.formly.setId(QualificationService.toFormId(this.responseId));
  }

  ngOnInit() {
    // TODO remove this part, it's useless
    this.qualificationFacade
      .getById(this.responseId)
      .pipe(untilDestroyed(this))
      .subscribe(qualification => (this.canFinishQualification = !!qualification && qualification.canInterrupt));
  }
}
